module.exports = __webpack_public_path__ + "img/43.8.TSS.cc7ff534.png";